module.exports = __webpack_public_path__ + "static/media/PW100.90359176.pdf";